export const RX_FORM_TYPES = {
  IDB: 'idb',
  RETAINER: 'retainer'
};

/** Custom Fields */
export const ATTRIBUTE_CUSTOM_FIELDS = 'custom_fields';

export const COMMON_ATTRIBUTES = {
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  CASE_NUMBER_TEXT: 'case_number_text',
  DOCTOR: 'user_id',
  NOTES: 'special_instructions',
  SHIPPING_LOCATION: 'shipping_location_id',
  SHIPPING_METHOD: 'shipping_method'
};

export const COMMON_QUESTIONS = {
  [COMMON_ATTRIBUTES.FIRST_NAME]: 'First Name',
  [COMMON_ATTRIBUTES.LAST_NAME]: 'Last Name',
  [COMMON_ATTRIBUTES.CASE_NUMBER_TEXT]: 'Case Number',
  [COMMON_ATTRIBUTES.DOCTOR]: 'Choose Doctor',
  [COMMON_ATTRIBUTES.NOTES]:
    'Any extractions and/or mixed dentition? This helps w/ case quality assurance.',
  [COMMON_ATTRIBUTES.SHIPPING_LOCATION]: 'Which Shipping Location?',
  [COMMON_ATTRIBUTES.SHIPPING_METHOD]: 'Which shipping option do you prefer?'
};

export const COMMON_VIEW_LABEL = {
  [COMMON_ATTRIBUTES.DOCTOR]: 'Who is the Doctor?',
  created_by_user_id: 'Filled By'
};
